<template>
  <Survey360ResultsView
    :surveyResult="surveyResult"
    :roles="roles"
    :clang="state.clan"
    :loading="loading"
    :subjectName="reportName"
  />
</template>

<script setup>
import Survey360ResultsView from "@/components/Survey360ResultsView";

import { computed, onMounted, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const route = useRoute();
const reportId = route.params.id;
const store = useStore();
const loading = ref(true);

const state = reactive({
  role: computed(() => store.state.survey360.roles),
  clan: computed(() => store.state.survey.currentLanguage),
});

async function setupData() {
  await store.dispatch("survey360/fetchGroupReportRoles", reportId);
  if (state.role && state.role.length === 0) return;
  store.dispatch("results/fetchSurvey360GroupReportAnswers", { reportId });
}

const roles = computed(() => store.getters["survey360/getRoles"]);

const surveyResult = computed(() => {
  const data = store.state.results.survey360Data;
  return data[reportId]?.["all"] ?? {};
});

const reportName = computed(() => surveyResult.value.name ?? "");

watch(surveyResult, (newResults) => {
  if (newResults !== {}) {
    loading.value = false;
  }
});

onMounted(() => {
  setupData();
});
</script>
